/*
 * THIS FILE WAS GENERATED BY "@atproto/lex". DO NOT EDIT.
 */

import { l } from '@atproto/lex'

const $nsid = 'app.bsky.notification.declaration'

type $nsid = typeof $nsid

export { $nsid }

/** A declaration of the user's choices related to notifications that can be produced by them. */
type Main = {
  $type: 'app.bsky.notification.declaration'

  /**
   * A declaration of the user's preference for allowing activity subscriptions from other users. Absence of a record implies 'followers'.
   */
  allowSubscriptions: 'followers' | 'mutuals' | 'none' | l.UnknownString
}

export type { Main }

/** A declaration of the user's choices related to notifications that can be produced by them. */
const main = /*#__PURE__*/ l.record<'literal:self', Main>(
  'literal:self',
  $nsid,
  /*#__PURE__*/ l.object({
    allowSubscriptions: /*#__PURE__*/ l.string<{
      knownValues: ['followers', 'mutuals', 'none']
    }>(),
  }),
)

export { main }

const $type = $nsid

type $type = typeof $type

export { $type }

export const $isTypeOf = /*#__PURE__*/ main.isTypeOf.bind(main)
export const $build = /*#__PURE__*/ main.build.bind(main)
export const $assert = /*#__PURE__*/ main.assert.bind(main)
export const $check = /*#__PURE__*/ main.check.bind(main)
export const $cast = /*#__PURE__*/ main.cast.bind(main)
export const $ifMatches = /*#__PURE__*/ main.ifMatches.bind(main)
export const $matches = /*#__PURE__*/ main.matches.bind(main)
export const $parse = /*#__PURE__*/ main.parse.bind(main)
export const $safeParse = /*#__PURE__*/ main.safeParse.bind(main)
export const $validate = /*#__PURE__*/ main.validate.bind(main)
export const $safeValidate = /*#__PURE__*/ main.safeValidate.bind(main)
